export default "/images/f4f4a8418850ca24fc276b4b8ee8dec6.jpg";